export default "__VITE_ASSET__CgO5Vglj__"